import { ThemeProvider } from 'lib/theme';
import AppShell from './AppShell';

// Theme (lib/theme.tsx), routes (src/routes.tsx) and layout (AppShell.tsx)
// were all split out of this file in Phase 6 -- see the plan's Phase 6 section.
export default function Main() {
    return (
        <ThemeProvider>
            <AppShell />
        </ThemeProvider>
    );
}
